import { axiosInstance } from "../../config/axios";
import { AxiosError } from "axios";
import { useMutation } from "react-query";
import { BasePagingResponse } from "../_types";

export type GetRoleActionListRequest = {
  page?: number;
  size?: number;
  orderByDesc?: boolean;
  orderBy?: string;
  status?: string;
  [key: string]: string | number | boolean | undefined;
};

export type IRoleAction = {
  id: number;
  roleId: number;
  menuIds: [number];
  create: boolean;
  read: boolean;
  update: boolean;
  delete: boolean;
  status: string | null;
  systemDate: string;
  createDate: string;
  createUserId: number;
  updateDate: null | string;
  updateUserId: number;
  deleteDate: null | string;
  deleteUserId: number;
};

export type GetRoleActionListResponse = BasePagingResponse<Array<IRoleAction>>;


async function getRoleMenuList(
  data: GetRoleActionListRequest
): Promise<GetRoleActionListResponse> {
  try {
    return (await axiosInstance.post("/RoleAction/List", data)).data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}


export function useGetRoleActionList(status?: string) {
  return useMutation<GetRoleActionListResponse, Error, GetRoleActionListRequest>(
    (variables) => getRoleMenuList({ ...variables, status })
  );
}